import styled, { keyframes } from "styled-components";
import { fadeInLeft } from "react-animations";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;
// Styles
export const SessionMainDiv = styled.div`
  margin: 0 auto 10px;
  max-width: 860px;
  @media (max-width: 910px) {
    margin: 0 auto 10px;
    width: 85%;
  }
`;
export const SessionDiv = styled.div`
  height: 50px;
  max-width: 660px;
  display: flex;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    height: auto;
    flex-direction: column;
    box-shadow: none;
    background: transparent;
    transition: all 0.5s ease-out;
  }
`;
export const InfoDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 270px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const SessionText = styled.p`
  width: ${({ width }) => width && width};
  font-size: 14px;
  text-align: center;
  @media (max-width: 910px) {
    width: ${({ width910 }) => width910 && width910};
    font-size: 12px;
  }
`;
export const ShowExtraInfoButton = styled.button`
  width: 35px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid #ccc;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const ShowExtraInfoImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ExtraInfoDiv = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 5px;
  @media (max-width: 910px) {
    margin-top: 2px;
    padding: 0 10px;
    width: 270px;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    display: ${({ show }) => (show ? "flex" : "none")};
    justify-content: justify-content: space-between;;
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const ExtraInfoSessionDiv = styled.div`
  padding: 5px 0 7px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 5px 5px 0;
  @media (max-width: 910px) {
    height: 50px;
  }
`;
export const ExtraInfoSessionTitle = styled.p`
  display: none;
  font-size: 12px;
  font-weight: 600;
  color: #808080;
  @media (max-width: 910px) {
    display: inline;
  }
`;
